export const round = (num: number) => Math.floor(Math.round(num * 100 + Number.EPSILON) / 100);
